import { CambiarClienteComponent } from '../../../../standalone/cambiar-cliente/cambiar-cliente.component';
import { Component, OnDestroy, OnInit, inject } from '@angular/core';
import {
  IDispositivoAlarma,
  IFilter,
  IQueryParam,
  IPopulate,
  IEventoGenerico,
} from 'modelos/src';
import { Subscription } from 'rxjs';
import { CamarasMultipleComponent } from '../../../../standalone/camaras-multiple/camaras-multiple.component';
import {
  IColumnas,
  ICrearBoton,
} from '../../../../../auxiliares/tabla/tabla.component';
import {
  IFiltroTabla,
  IRegExpSearch,
} from '../../../../../auxiliares/tabla/filtro/filtro.component';
import { HelperService } from '../../../../../auxiliares/servicios/helper.service';
import {
  estadoConexionAlarma,
  ultimaComunicacionAlarma,
} from '../../../../../auxiliares/comunicadores-alarma.util';
import {
  estadoHtml,
  fechaCelda,
  haceCelda,
} from '../../../../../auxiliares/tabla/celdas';
import {
  IEstadoCelda,
  TonoEstado,
} from '../../../../../auxiliares/tabla/tabla.interfaces';
import { PermisosEntidadesService } from '../../../../../auxiliares/servicios/http/permisos-entidades.service';
import { isModoDesactivadoActivo } from '../../../../../auxiliares/modo-desactivado.util';
import { DialogService } from '../../../../../auxiliares/dialog/dialog.service';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import {
  AlarmasDomiciliariasService,
  EstadoReportingAlarma,
  IEstadoAlarmaResult,
} from '../alarmas-domiciliarias.service';
import { ConfigurarComunicadorComponent } from '../configurar-comunicador/configurar-comunicador.component';
import { LoginService } from '../../../../login/login.service';
import { ModoDesactivadoDispositivoComponent } from '../../../../standalone/modo-desactivado-dispositivo/modo-desactivado-dispositivo.component';
import { Lista2Service } from '../../../../../auxiliares/servicios/lista2.service';
import { CrearEditarEstadoCuentaComponent } from '../../../administracion/estado-entidad/crear-editar-estado-cuenta/crear-editar-estado-cuenta.component';
import { DarAltaEntidadComponent } from '../../../../standalone/dar-alta-entidad/dar-alta-entidad.component';
import { EventosGenericosHttpService } from '../../../../../auxiliares/servicios/http/eventos-genericos.service';
import {
  CrearEditarEventoTecnicoGenericoComponent,
  ICrearEditarEventoTecnicoGenericoData,
} from '../../../eventos-genericos/eventos-tecnicos-genericos/crear-editar/crear-editar-evento-tecnico-generico.component';
import { ClienteJerarquiaService } from '../../../../../auxiliares/servicios/cliente-jerarquia.service';
import { escaparHtml } from '../../../../../auxiliares/html-seguro.util';
import { FormularioDialogService } from '../../../../../auxiliares/servicios/formulario-dialog.service';

/** Comunicación de la alarma → tono e ícono (igual que estadoConexionCelda). */
const TONO_CONEXION_ALARMA: Record<string, [TonoEstado, string]> = {
  ok: ['ok', 'cloud_done'],
  advertencia: ['aviso', 'schedule'],
  apagado: ['neutro', 'cloud_off'],
  neutro: ['neutro', 'question_mark'],
};

/** Reporting calculado por el backend (isAlive), con los nombres del detalle. */
const REPORTING_ALARMA: Record<
  EstadoReportingAlarma,
  { texto: string; tono: TonoEstado; icono: string }
> = {
  verde: { texto: 'Reportando', tono: 'ok', icono: 'cloud_done' },
  naranja: { texto: 'Demorado', tono: 'aviso', icono: 'schedule' },
  rojo: { texto: 'Sin reportar', tono: 'neutro', icono: 'cloud_off' },
  gris: { texto: 'Sin información', tono: 'neutro', icono: 'question_mark' },
};

/** Color del tema para un tono, fuera de app-tabla (diálogos). */
function colorTono(tono: TonoEstado): string {
  const color = {
    ok: 'green',
    aviso: 'orange',
    error: 'red',
    info: 'blue',
    neutro: 'gray',
  }[tono];
  return `var(--color-${color}-text)`;
}

@Component({
  selector: 'app-listado-alarmas-domiciliarias',
  templateUrl: './listado-alarmas-domiciliarias.component.html',
  styleUrl: './listado-alarmas-domiciliarias.component.scss',
  standalone: false,
})
export class ListadoAlarmasDomiciliariasComponent implements OnInit, OnDestroy {
  private clienteJerarquia = inject(ClienteJerarquiaService);
  private lista2Service = inject(Lista2Service);
  helper = inject(HelperService);
  private permisosEntidades = inject(PermisosEntidadesService);
  private dialogService = inject(DialogService);
  private service = inject(AlarmasDomiciliariasService);
  dialog = inject(MatDialog);
  private formularios = inject(FormularioDialogService);
  private navigator = inject(Router);
  private route = inject(ActivatedRoute);
  private eventosService = inject(EventosGenericosHttpService);

  public loading = false;
  public clientePropio = LoginService.getCliente();
  //// Tabla nueva
  public name = 'ListadoAlarmasDomiciliariasComponent';

  public alarmasDomiciliarias?: IDispositivoAlarma[];
  public totalCount = 0;
  public columnas?: IColumnas<IDispositivoAlarma>[];
  public isAliveMap: Record<string, IEstadoAlarmaResult> = {};
  public isAliveLoading = new Set<string>();
  private chequeoInicialHecho = false;
  //Subs
  public modelo$?: Subscription;
  public alarmasDomiciliarias$?: Subscription;

  ///////////////////////////////////////////////
  public eventos$: Subscription;
  ////////////////////////////////////////////////
  //
  public botonCrear: ICrearBoton = {
    mostrar: this.helper.tienePermiso('Alarmas - Crear'),
    tooltip: 'Crear alarma domiciliaria',
    color: 'primary',
    tipo: 'material',
    icon: 'add',
    accion: () => this.crear(),
  };
  public search: IRegExpSearch = {
    fields: ['nombre'],
  };
  // FILTROS
  //Cliente
  public cliente: IFiltroTabla = {
    filter: {
      field: 'idCliente',
    },
    label: 'Cliente',
    tipo: 'cliente-selector',
    filtroSelector: ['moduloAlarmasDomiciliarias'],
  };
  public ancestro: IFiltroTabla = {
    filter: {
      field: 'idsAncestros',
      incluirPropio: true,
    },
    label: 'En la jerarquía de',
    tipo: 'cliente-selector',
    filtroSelector: ['moduloAlarmasDomiciliarias'],
  };
  //Modelo
  public modelo: IFiltroTabla = {
    filter: {
      field: 'idModelo',
    },
    label: 'Modelo de alarma',
    tipo: 'modelo-dispositivo-selector',
    tipoDispositivo: 'Alarma',
  };

  //Modelo de comunicador — filtra por cualquiera de los comunicadores[] de la
  // alarma (Mongo matchea un dot-path de array contra CUALQUIER elemento).
  public comunicador: IFiltroTabla = {
    filter: {
      field: 'comunicadores.idComunicador',
    },
    label: 'Modelo de comunicador',
    tipo: 'modelo-dispositivo-selector',
    tipoDispositivo: 'Comunicador',
  };

  //Estado de la cuenta
  private habilitado: IFiltroTabla = {
    elementos: [
      {
        label: 'Habilitado',
        icon: 'check_circle',
        iconColor: 'var(--color-green-text)',
        filter: [{ estadoCuenta: null }, { estadoCuenta: 'Habilitado' }],
      },
      {
        label: 'Suspendido',
        icon: 'block',
        iconColor: 'var(--color-red-text)',
        filter: [{ estadoCuenta: 'Suspendido' }],
      },
    ],
    filter: {
      field: '$or',
    },
    label: 'Habilitación',
    rapido: true,
    rapidoLabel: 'Cuenta',
    rapidoAyuda: 'Estado de la cuenta de la alarma: habilitada o suspendida.',
    tipo: 'ngselect',
    selectIcon: true,
    selectLabel: 'label',
    selectValue: 'filter',
  };

  //Alta o no alta
  private alta: IFiltroTabla = {
    elementos: [
      {
        label: 'Dado de alta',
        value: [{ fechaAlta: { $exists: true, $ne: null } }],
      },
      { label: 'Sin alta', value: [{ fechaAlta: null }] },
    ],
    filter: {
      field: '$or',
    },
    label: 'Alta',
    tipo: 'ngselect',
    selectLabel: 'label',
    selectValue: 'value',
  };

  //Comunicación
  private comunicacion: IFiltroTabla = {
    elementos: [
      {
        label: 'Reportó alguna vez',
        icon: 'cloud_done',
        iconColor: 'var(--color-green-text)',
        // La fecha vive en cada comunicador (comunicadores[]), no en la alarma
        value: [
          {
            comunicadores: {
              $elemMatch: {
                fechaUltimaComunicacion: { $exists: true, $ne: null },
              },
            },
          },
        ],
      },
      {
        label: 'Nunca reportó',
        icon: 'cloud_off',
        iconColor: 'var(--color-gray-text)',
        value: [
          {
            comunicadores: {
              $not: {
                $elemMatch: {
                  fechaUltimaComunicacion: { $exists: true, $ne: null },
                },
              },
            },
          },
        ],
      },
    ],
    filter: {
      field: '$or',
    },
    label: 'Comunicación',
    rapido: true,
    rapidoLabel: 'Reportes',
    rapidoAyuda:
      'Si la alarma reportó alguna vez. Si hoy está reportando o demorada se ve en la columna Estado.',
    tipo: 'ngselect',
    selectIcon: true,
    selectLabel: 'label',
    selectValue: 'value',
  };

  //Modo desactivado
  private activacion: IFiltroTabla = {
    elementos: [
      {
        label: 'Activa',
        icon: 'toggle_on',
        iconColor: 'var(--color-green-text)',
        filter: [
          { 'modoDesactivado.dispositivoDesactivado': null },
          { 'modoDesactivado.dispositivoDesactivado': false },
        ],
      },
      {
        label: 'Desactivada',
        icon: 'do_not_disturb_on',
        iconColor: 'var(--color-gray-text)',
        filter: [{ 'modoDesactivado.dispositivoDesactivado': true }],
      },
    ],
    filter: {
      field: '$or',
    },
    label: 'Activación',
    rapido: true,
    rapidoLabel: 'Equipo',
    rapidoAyuda:
      'Modo desactivado del equipo: una alarma desactivada no genera eventos.',
    tipo: 'ngselect',
    selectIcon: true,
    selectLabel: 'label',
    selectValue: 'filter',
  };

  //Fecha de alta
  private fechaAlta: IFiltroTabla = {
    filter: {
      field: 'fechaAlta',
    },
    label: 'Buscar fecha de alta',
    tipo: 'dateRange',
  };

  public filtros: IFiltroTabla[] = [
    this.modelo,
    this.comunicador,
    this.habilitado,
    this.alta,
    this.comunicacion,
    this.fechaAlta,
    this.activacion,
  ];
  //Query
  public filter: IFilter<IDispositivoAlarma> = {};
  public populate: IPopulate[] = [
    {
      path: 'domicilio',
    },
    {
      path: 'modelo',
      populate: { path: 'codigos' },
    },
    {
      path: 'cliente',
      select: 'nombre idPadre nivel',
    },
    {
      path: 'comunicador',
    },
    {
      path: 'camaras',
      select: 'identificacion',
    },
    {
      path: 'serviciosContratados',
      select: 'nombre icono',
    },
    {
      path: 'sim1',
    },
    {
      path: 'sim2',
    },
  ];
  public query: IQueryParam = {
    filter: JSON.stringify(this.filter),
    populate: JSON.stringify(this.populate),
    sort: 'nombre',
    page: 0,
    limit: +this.helper.getPageSize(this.name),
    includeChildren: true,
    childrenLevel: 0,
  };

  public async listar(): Promise<void> {
    this.alarmasDomiciliarias$?.unsubscribe();
    this.alarmasDomiciliarias$ = this.lista2Service
      .dispositivosAlarmas(this.query, 30)
      .subscribe((data) => {
        this.totalCount = data.totalCount;
        this.alarmasDomiciliarias = data.datos;
        if (!this.chequeoInicialHecho) {
          this.chequeoInicialHecho = true;
          this.cargarEstadosVivos(data.datos);
        }
      });
  }

  private async cargarEstadosVivos(
    alarmas: IDispositivoAlarma[],
  ): Promise<void> {
    if (!alarmas?.length) return;
    const ids = alarmas.map((a) => a._id).filter((id): id is string => !!id);
    if (!ids.length) return;
    ids.forEach((id) => this.isAliveLoading.add(id));
    try {
      const resultados = await this.service.isAliveBatch(ids);
      for (const r of resultados) {
        this.isAliveMap[r.id] = r;
      }
    } catch (error) {
      console.error('Error cargando estados de alarmas', error);
    } finally {
      ids.forEach((id) => this.isAliveLoading.delete(id));
    }
  }

  public async rechequearEstado(alarma: IDispositivoAlarma) {
    const id = alarma._id!;
    this.isAliveLoading.add(id);
    try {
      const [resultado] = await this.service.isAliveBatch([id]);
      if (resultado) {
        this.isAliveMap[id] = resultado;
      }
    } catch (error) {
      this.helper.notifError(error);
      return;
    } finally {
      this.isAliveLoading.delete(id);
    }
    await this.verDetalleEstado(alarma);
  }

  public async verDetalleEstado(alarma: IDispositivoAlarma) {
    const r = this.isAliveMap[alarma._id || ''];
    if (!r) {
      this.helper.notifError(
        'Sin información de estado todavía. Probá volver a chequear.',
      );
      return;
    }
    const html = this.renderDetalleEstadoHtml(alarma, r);
    await this.dialogService.dialog(
      `Estado de ${alarma.nombre}`,
      html,
      'Cerrar',
    );
  }

  private renderDetalleEstadoHtml(
    alarma: IDispositivoAlarma,
    r: IEstadoAlarmaResult,
  ): string {
    // El diálogo vive fuera de app-tabla: colores del tema, sin la píldora
    const e = this.getEstadoAlarma(alarma);
    const icono = (nombre: string) =>
      `<span class="material-symbols-outlined" style="font-size: 13px; vertical-align: middle;">${nombre}</span>`;
    let html = `<div style="display:flex; flex-direction:column; gap:12px; text-align:left;">`;

    // Cabecera estado
    html += `<div style="display:flex; align-items:center; gap:8px; color:${colorTono(e.tono)};">
      <span class="material-symbols-outlined" style="font-size:28px;">${e.icono}</span>
      <strong style="font-size:16px;">${escaparHtml(e.texto)}</strong>
    </div>`;

    // Configuración
    html += `<div><strong>Configuración:</strong>`;
    if (r.configOk) {
      html += ` <span style="color:${colorTono('ok')};">${icono('check_circle')} Completa</span>`;
    } else if (r.configFaltante.length) {
      const items = r.configFaltante
        .map((c) => `<li>${escaparHtml(this.traducirFaltante(c))}</li>`)
        .join('');
      html += `<div style="color:${colorTono('aviso')};">${icono('warning')} Faltan campos:<ul style="margin:4px 0 0 18px;">${items}</ul></div>`;
    } else {
      html += ` <span class="no-info">Sin datos</span>`;
    }
    html += `</div>`;

    // Datos OK
    html += `<div><strong>Datos cargados:</strong><ul style="margin:4px 0 0 18px;">`;
    html += `<li>Alta: ${r.alta ? (alarma.fechaAlta ? fechaCelda(alarma.fechaAlta) : 'Sí') : '<span class="no-info">Pendiente</span>'}</li>`;
    html += `<li>Formato: ${r.formatoMensaje ? escaparHtml(r.formatoMensaje) : '<span class="no-info">Sin formato</span>'}</li>`;
    html += `<li>N° de sistema/serie: ${alarma.nroDeSistema ? escaparHtml(alarma.nroDeSistema) : '<span class="no-info">Sin número</span>'}</li>`;
    html += `<li>Frecuencia de reporte: ${alarma.frecReporte ? alarma.frecReporte + ' min' : '<span class="no-info">Sin frecuencia</span>'}</li>`;
    html += `</ul></div>`;

    // Comunicación
    html += `<div><strong>Comunicación:</strong><div>`;
    if (r.fechaUltimaComunicacion) {
      const rep = REPORTING_ALARMA[r.reporting] ?? REPORTING_ALARMA.gris;
      html += `<span style="color:${colorTono(rep.tono)};">${icono(rep.icono)} ${rep.texto}</span> · última ${fechaCelda(r.fechaUltimaComunicacion)} (${haceCelda(r.fechaUltimaComunicacion)})`;
    } else {
      html += `<span class="no-info">Sin comunicación registrada</span>`;
    }
    html += `</div></div>`;

    // Vendor
    if (r.vendorAplica) {
      html += `<div><strong>Sistema del fabricante (${escaparHtml(r.formatoMensaje)}):</strong><div>`;
      if (r.vendorOk === true) {
        html += `<span style="color:${colorTono('ok')};">${icono('check_circle')} Cargada y respondió</span>`;
        if (r.vendorResultado) {
          html += `<details style="margin-top:6px;"><summary style="cursor:pointer;">Ver respuesta</summary><pre style="max-height:30vh; overflow:auto; background:var(--color-gray-bg); padding:8px; border-radius:4px;">${escaparHtml(JSON.stringify(r.vendorResultado, null, 2))}</pre></details>`;
        }
      } else if (r.vendorOk === false) {
        html += `<span style="color:${colorTono('error')};">${icono('error')} No respondió o no está cargada</span>`;
        if (r.vendorMensaje) {
          html += `<div class="no-info" style="margin-top:4px;">${escaparHtml(r.vendorMensaje)}</div>`;
        }
      } else {
        html += `<span class="no-info">Sin chequear</span>`;
      }
      html += `</div></div>`;
    } else {
      html += `<div><strong>Sistema del fabricante:</strong> <span class="no-info">No aplica para este formato</span></div>`;
    }

    html += `</div>`;
    return html;
  }

  /** Estado consolidado (isAlive) de la alarma como pieza de estado. */
  private getEstadoAlarma(dato: IDispositivoAlarma): IEstadoCelda {
    const id = dato._id || '';
    if (this.isAliveLoading.has(id)) {
      return { texto: 'Cargando…', tono: 'info', icono: 'hourglass_top' };
    }
    const r = this.isAliveMap[id];
    if (!r) {
      return {
        texto: 'Sin información',
        tono: 'neutro',
        icono: 'question_mark',
      };
    }
    switch (r.estado) {
      case 'online':
        return { texto: 'En línea', tono: 'ok', icono: 'cloud_done' };
      case 'offline':
        return { texto: 'Sin conexión', tono: 'error', icono: 'cloud_off' };
      case 'incompleta':
        return {
          texto: 'Configuración incompleta',
          tono: 'aviso',
          icono: 'warning',
        };
      default:
        return { texto: 'Desconocido', tono: 'neutro', icono: 'question_mark' };
    }
  }

  /**
   * Comunicación con el criterio del módulo de alarmas (el mismo que el
   * detalle y el backend): Reportando / Demorado / Sin reportar.
   */
  private getComunicacion(dato: IDispositivoAlarma): IEstadoCelda {
    const e = estadoConexionAlarma(dato);
    const [tono, icono] = TONO_CONEXION_ALARMA[e.tono] ?? [
      'neutro',
      'question_mark',
    ];
    return { texto: e.etiqueta, tono, icono };
  }

  /** Armado de las particiones: estado sin ícono (no hay uno en la guía). */
  private getArmado(
    dato: IDispositivoAlarma,
  ): { estado: IEstadoCelda; detalle: string } | undefined {
    if (!dato.armado || !Array.isArray(dato.armado)) return undefined;
    const armadas = dato.armado.filter((p) => p === true).length;
    const total = dato.armado.length;
    if (total > 0 && armadas === total) {
      return {
        estado: { texto: 'Armada', tono: 'info' },
        detalle: `${total} ${total === 1 ? 'partición' : 'particiones'}`,
      };
    }
    if (armadas > 0) {
      return {
        estado: { texto: 'Parcialmente armada', tono: 'info' },
        detalle: `${armadas}/${total} particiones`,
      };
    }
    return { estado: { texto: 'Desarmada', tono: 'neutro' }, detalle: '' };
  }

  private traducirFaltante(campo: string): string {
    switch (campo) {
      case 'comunicador':
        return 'Comunicador';
      case 'idUnicoComunicador':
        return 'ID único del comunicador';
      case 'frecReporte':
        return 'Frecuencia de reporte';
      case 'nroDeSistema':
        return 'N° de sistema/serie';
      default:
        return campo;
    }
  }

  // Acciones
  public async crear() {
    this.navigator.navigate(['crear'], { relativeTo: this.route });
  }

  public async editar(dispositivoAlarma: IDispositivoAlarma) {
    this.navigator.navigate(['editar', dispositivoAlarma._id], {
      relativeTo: this.route,
    });
  }
  public async cambiarCliente(alarma: IDispositivoAlarma) {
    const dialogRef = this.formularios.abrir(CambiarClienteComponent, {
      tamano: 'mediano',
      data: {
        entidad: alarma,
        tipoEntidad: 'Alarma',
      },
    });
    dialogRef.afterClosed().subscribe(async (resultado) => {
      if (resultado) {
        await this.listar();
      }
    });
  }

  public async crearEstadoEntidad(alarma: IDispositivoAlarma) {
    const dialogRef = this.formularios.abrir(CrearEditarEstadoCuentaComponent, {
      tamano: 'chico',
      data: { alarma },
    });
    dialogRef.afterClosed().subscribe(async (resultado) => {
      if (resultado) {
        await this.listar();
      }
    });
  }

  public verDetalles(alarma: IDispositivoAlarma): void {
    this.navigator.navigate([
      'main/alarmas/alarmasDomiciliarias/detallesAlarma',
      alarma._id,
    ]);
  }

  public async verStream(alarma: IDispositivoAlarma) {
    if (!alarma.camaras || alarma.camaras.length === 0) return;

    const idsCamaras = alarma.camaras.map((camara) => camara._id!);

    const dialogs = this.dialog.openDialogs;
    const idAbierto = dialogs.find(
      (d) =>
        d.componentInstance.data &&
        idsCamaras.some((id) => d.componentInstance.data.data?.includes(id)),
    );

    if (!idAbierto) {
      CamarasMultipleComponent.open(this.dialog, { data: idsCamaras });
    }
  }

  public async exportarEventos(dispositivoAlarma: IDispositivoAlarma) {
    const rango = await this.dialogService.dateRange(
      'Exportar eventos',
      'Seleccioná el rango de fechas para exportar los eventos',
    );
    if (!rango) return;

    const filter: IFilter<IEventoGenerico> = {
      idEntidad: dispositivoAlarma._id,
      fechaCreacion: {
        $gte: rango?.start,
        $lte: rango?.end,
      },
    };

    const populate: IPopulate[] = [
      {
        path: 'alarma',
        select: 'nombre',
      },
      {
        path: 'cliente',
        select: 'nombre',
      },
    ];

    const query: IQueryParam = {
      filter: JSON.stringify(filter),
      sort: 'fechaCreacion',
      page: 0,
      limit: 0,
      unlimited: true,
      includeChildren: true,
      populate: JSON.stringify(populate),
    };

    const config = {
      columns: [
        {
          header: 'Cliente',
          key: 'cliente.nombre',
        },
        {
          header: 'Categoría',
          key: 'categoria',
        },
        {
          header: 'Entidad',
          key: 'alarma.nombre',
        },
        {
          header: 'Evento',
          key: 'valores.titulo',
        },
        {
          header: 'Detalles',
          key: 'valores.mensaje',
        },
        {
          header: 'Fecha',
          key: 'fechaCreacion',
        },
      ],
      sheetName: 'Eventos',
      autoFilter: true,
    };

    try {
      await this.eventosService.exportar(
        query,
        config,
        dispositivoAlarma.nombre,
      );
    } catch (error) {
      console.error(error);
      this.helper.notifError(error);
    }
  }

  public async modoDesactivado(dispositivoAlarma: IDispositivoAlarma) {
    const dialog = this.formularios.abrir(ModoDesactivadoDispositivoComponent, {
      tamano: 'chico',
      data: { alarma: dispositivoAlarma },
    });

    dialog.afterClosed().subscribe(async (resultado) => {
      if (resultado) {
        await this.listar();
      }
    });
  }

  //Esto funciona en Irix Mobile
  // public async accionesAlarma(dispositivoAlarma: IDispositivoAlarma) {
  //   this.dialog.open(AccionesAlarmaComponent, {
  //     data: { alarma: dispositivoAlarma },
  //     width: '850px',
  //   });
  // }

  public async darAlta(dispositivoAlarma: IDispositivoAlarma) {
    this.formularios.abrir(DarAltaEntidadComponent, {
      tamano: 'mediano',
      data: { alarma: dispositivoAlarma },
    });
  }

  public async actualizarImagenes(dispositivoAlarma: IDispositivoAlarma) {
    this.formularios.abrir(DarAltaEntidadComponent, {
      tamano: 'mediano',
      data: { alarma: dispositivoAlarma },
    });
  }
  public async configurarComunicador(dispositivoAlarma: IDispositivoAlarma) {
    this.formularios.abrir(ConfigurarComunicadorComponent, {
      tamano: 'mediano',
      data: dispositivoAlarma,
    });
  }

  public async eventoTecnico(alarma: IDispositivoAlarma) {
    const data: ICrearEditarEventoTecnicoGenericoData = {
      idEntidad: alarma._id!,
      tipoEvento: 'Evento Técnico Alarma',
      categoria: 'Alarma',
      idsCQAET: [this.clientePropio!._id!],
    };

    this.formularios.abrir(CrearEditarEventoTecnicoGenericoComponent, {
      tamano: 'grande',
      data,
    });
  }

  public parseCamaras(dato: IDispositivoAlarma) {
    let text = dato.camaras.map((camara) => camara.identificacion).join(', ');
    if (text) {
      if (text.length >= 50) {
        text = text.slice(0, 50);
        text += '...';
      }
      return text;
    } else {
      return '';
    }
  }

  public async eliminar(dispositivoAlarma: IDispositivoAlarma) {
    const res = await this.dialogService.confirm(
      'Eliminar alarma domiciliaria',
      `¿Querés eliminar la alarma ${dispositivoAlarma.modelo?.marca} ${dispositivoAlarma.modelo?.modelo} | ${dispositivoAlarma.domicilio?.direccion}?`,
    );
    if (!res) return;
    try {
      await this.service.delete(dispositivoAlarma._id!);
      this.helper.notifSuccess('Alarma domiciliaria eliminada');
      await this.listar();
    } catch (error) {
      console.error(error);
      this.helper.notifError(error);
    }
  }

  // Tabla

  private isActivamenteDesactivado(dato: IDispositivoAlarma): boolean {
    return isModoDesactivadoActivo(dato.modoDesactivado);
  }

  /** Suspensión y modo desactivado, como estados (sólo si los hay). */
  private getEstadoBadges(dato: IDispositivoAlarma): string {
    const badges: string[] = [];
    if (dato.estadoCuenta === 'Suspendido') {
      badges.push(
        estadoHtml({ texto: 'Suspendido', tono: 'error', icono: 'block' }),
      );
    }
    if (this.isActivamenteDesactivado(dato)) {
      badges.push(
        estadoHtml({
          texto: 'Desactivada',
          tono: 'neutro',
          icono: 'do_not_disturb_on',
        }),
      );
    }
    return badges.map((b) => `<span>${b}</span>`).join('');
  }

  /**
   * Servicios contratados: la imagen de cada uno (o su inicial), con el
   * nombre en el title.
   */
  private getServiciosHtml(dato: IDispositivoAlarma): string {
    if (!dato.serviciosContratados || dato.serviciosContratados.length === 0) {
      return '';
    }

    const iconosHtml = dato.serviciosContratados
      .map((s) => {
        if (s.icono) {
          return `<img src="${escaparHtml(s.icono)}" alt="${escaparHtml(s.nombre)}" title="${escaparHtml(s.nombre)}" style="width: 28px; height: 28px; object-fit: contain; border-radius: 4px;" />`;
        }
        // Si no tiene icono, mostrar inicial del nombre
        const inicial = s.nombre?.charAt(0)?.toUpperCase() || '?';
        return `<span class="tabla-principal" style="width: 28px; height: 28px; border: 1px solid currentColor; border-radius: 4px; display: inline-flex; align-items: center; justify-content: center; font-size: 12px;" title="${escaparHtml(s.nombre)}">${escaparHtml(inicial)}</span>`;
      })
      .join('');

    return `<div class="tabla-celda-fila" style="gap: 4px; flex-wrap: wrap;">${iconosHtml}</div>`;
  }

  private setColumnas() {
    const columnas: IColumnas<IDispositivoAlarma>[] = [
      // Nombre + estados (sólo si los hay)
      {
        header: {
          label: 'Nombre',
          sortable: true,
          sort: 'nombre',
        },
        row: {
          html: (dato) => {
            const nombre = dato.nombre || 'Sin nombre';
            return `<div class="tabla-celda-col">
              <span class="tabla-principal">${escaparHtml(nombre)}</span>
              ${this.getEstadoBadges(dato)}
            </div>`;
          },
          tooltip: (dato) => {
            const estados: string[] = [];
            if (dato.estadoCuenta === 'Suspendido')
              estados.push('Cuenta suspendida');
            if (this.isActivamenteDesactivado(dato))
              estados.push('Dispositivo desactivado');
            return estados.length > 0 ? estados.join(' | ') : undefined;
          },
        },
      },

      // Alarma + Nº de sistema + armado
      {
        header: {
          label: 'Alarma',
        },
        row: {
          html: (dato) => {
            const marca = dato.modelo?.marca || '';
            const modelo = dato.modelo?.modelo || '';
            const nroSistema = dato.nroDeSistema;

            if (!marca && !modelo) {
              return '<span class="no-info">Sin modelo</span>';
            }

            let alarmaText = `${marca} ${modelo}`.trim();
            if (alarmaText.length > 35) {
              alarmaText = alarmaText.slice(0, 35) + '...';
            }

            let html = `<div class="tabla-celda-col">`;
            html += `<span class="tabla-principal">${escaparHtml(alarmaText)}</span>`;
            if (nroSistema) {
              html += `<span class="tabla-secundario">Nº ${escaparHtml(nroSistema)}</span>`;
            }
            // Armado: estado con texto (no hay ícono de armada en la guía)
            const armado = this.getArmado(dato);
            if (armado) {
              html += `<span>${estadoHtml(armado.estado)}</span>`;
            }
            html += `</div>`;
            return html;
          },
          tooltip: (dato) => {
            const items: string[] = [];
            if (dato.modelo?.marca)
              items.push(
                `<div>Marca: <strong>${escaparHtml(dato.modelo.marca)}</strong></div>`,
              );
            if (dato.modelo?.modelo)
              items.push(
                `<div>Modelo: <strong>${escaparHtml(dato.modelo.modelo)}</strong></div>`,
              );
            if (dato.nroDeSistema)
              items.push(
                `<div>Nº de sistema: <strong>${escaparHtml(dato.nroDeSistema)}</strong></div>`,
              );
            const armado = this.getArmado(dato);
            if (armado) {
              items.push(
                `<div>Estado: <strong>${armado.estado.texto}</strong>${armado.detalle ? ` (${armado.detalle})` : ''}</div>`,
              );
            }
            return items.length > 0 ? items.join('') : undefined;
          },
          noData: 'Sin modelo',
        },
      },

      // Servicios contratados (íconos)
      {
        header: {
          label: 'Servicios',
        },
        row: {
          html: (dato) => this.getServiciosHtml(dato),
          tooltip: (dato) => {
            if (
              !dato.serviciosContratados ||
              dato.serviciosContratados.length === 0
            ) {
              return 'Sin servicios contratados';
            }
            const items = dato.serviciosContratados
              .map(
                (s) =>
                  `<div style="padding: 2px 0;">• ${escaparHtml(s.nombre)}</div>`,
              )
              .join('');
            return `<div style="font-weight: 500; margin-bottom: 4px;">Servicios contratados:</div>${items}`;
          },
          noData: 'Sin servicios',
        },
      },

      // Domicilio
      {
        header: {
          label: 'Domicilio',
          sortable: false,
        },
        row: {
          parse: (dato) => {
            return HelperService.extraerDireccion(dato.domicilio?.direccion);
          },
          noData: 'Sin dirección',
          tooltip: (dato) => dato.domicilio?.direccion,
        },
      },

      // Cámaras
      {
        header: {
          label: 'Cámaras',
          sortable: false,
        },
        row: {
          html: (dato) => {
            if (!dato.camaras || dato.camaras.length === 0) {
              return '';
            }
            return `<div class="tabla-linea">
              <span class="material-symbols-outlined">videocam</span>
              <span class="tabla-principal">${dato.camaras.length}</span>
            </div>`;
          },
          tooltip: (dato) => {
            if (!dato.camaras || dato.camaras.length === 0)
              return 'Sin cámaras asociadas';
            const items = dato.camaras
              .map(
                (c) =>
                  `<div style="padding: 2px 0;"><span class="material-symbols-outlined" style="font-size: 13px; vertical-align: middle;">videocam</span> ${escaparHtml(c.identificacion)}</div>`,
              )
              .join('');
            return `<div style="font-weight: 500; margin-bottom: 4px;">Cámaras (${dato.camaras.length}):</div>${items}`;
          },
          noData: 'Sin cámaras',
        },
      },

      // Estado consolidado + comunicación + fecha de alta
      {
        header: {
          label: 'Estado',
          sortable: true,
          sort: 'comunicadores.fechaUltimaComunicacion',
          // Dos estados, fecha con "hace x", alta y faltantes: más ancha
          ancho: 1.7,
        },
        row: {
          html: (dato) => {
            const r = this.isAliveMap[dato._id || ''];
            let html = `<div class="tabla-celda-col">`;

            // Estado consolidado (isAlive)
            html += `<span>${estadoHtml(this.getEstadoAlarma(dato))}</span>`;

            // Comunicación: mismo criterio que el detalle de la alarma
            html += `<span>${estadoHtml(this.getComunicacion(dato))}</span>`;
            const ultimaComunicacion = ultimaComunicacionAlarma(dato);
            if (ultimaComunicacion) {
              html += `<span class="tabla-secundario">${fechaCelda(ultimaComunicacion)} · ${haceCelda(ultimaComunicacion)}</span>`;
            }

            // Fecha de alta
            html += dato.fechaAlta
              ? `<span class="tabla-secundario">Alta ${fechaCelda(dato.fechaAlta).slice(0, 10)}</span>`
              : `<span class="tabla-secundario no-info">Sin alta</span>`;

            // Configuración faltante (computada en backend)
            if (r?.configFaltante?.length) {
              const items = r.configFaltante
                .map((c) => this.traducirFaltante(c))
                .join(', ');
              html += `<span>${estadoHtml({ texto: `Falta: ${items}`, tono: 'aviso', icono: 'warning' })}</span>`;
            }

            html += `</div>`;
            return html;
          },
          tooltip: (dato) => {
            const r = this.isAliveMap[dato._id || ''];
            let html =
              '<div style="display: flex; flex-direction: column; gap: 6px;">';

            html += `<div><strong>${this.getEstadoAlarma(dato).texto}</strong></div>`;

            html += dato.fechaAlta
              ? `<div>Alta: <strong>${fechaCelda(dato.fechaAlta)}</strong></div>`
              : `<div>Sin fecha de alta</div>`;

            const ultimaComunicacionTooltip = ultimaComunicacionAlarma(dato);
            if (ultimaComunicacionTooltip) {
              html += `<div>Última comunicación: <strong>${fechaCelda(ultimaComunicacionTooltip)}</strong> (${haceCelda(ultimaComunicacionTooltip)})</div>`;
              html += `<div>Comunicación: <strong>${escaparHtml(this.getComunicacion(dato).texto)}</strong></div>`;
              html += dato.frecReporte
                ? `<div>Cada ${dato.frecReporte} min</div>`
                : `<div>Sin frecuencia de reporte configurada</div>`;
            } else {
              html += `<div>Sin comunicación registrada</div>`;
            }

            if (r?.configFaltante?.length) {
              const items = r.configFaltante
                .map((c) => `<li>${this.traducirFaltante(c)}</li>`)
                .join('');
              html += `<div><span class="material-symbols-outlined" style="font-size: 13px; vertical-align: middle;">warning</span> <strong>Configuración incompleta:</strong><ul style="margin:4px 0 0 16px; padding:0;">${items}</ul></div>`;
            } else if (dato.nroDeSistema) {
              html += `<div>N° de sistema/serie: <strong>${escaparHtml(dato.nroDeSistema)}</strong></div>`;
            }
            html += '</div>';
            return html;
          },
        },
      },
    ];

    // Cliente
    if (HelperService.getTipoCliente() !== 'Final') {
      {
        columnas.push({
          header: {
            label: 'Cliente',
          },
          row: {
            html: (dato) => this.clienteJerarquia.htmlNombre(dato.cliente),
            tooltip: (dato) =>
              this.clienteJerarquia.tooltipJerarquia(dato.cliente),
          },
        });
      }
    }

    // Acciones (orden y submenú Más acciones como estaban)
    columnas.push({
      header: {
        label: 'Acciones',
      },
      row: {
        accionesGrouped: [
          // Ver detalle
          {
            tipo: 'material',
            color: 'primary',
            icon: 'visibility',
            tooltip: 'Ver detalle',
            click: (dato) => this.verDetalles(dato),
          },

          // Editar
          {
            tipo: 'material',
            color: 'primary',
            icon: 'edit',
            tooltip: 'Editar',
            click: (dato) => this.editar(dato),
            disabled: () => !this.helper.tienePermiso('Alarmas - Editar'),
          },
          // Eliminar
          {
            tipo: 'material',
            color: 'warn',
            icon: 'delete',
            tooltip: 'Eliminar',
            click: (dato) => this.eliminar(dato),
            disabled: () => !this.helper.tienePermiso('Alarmas - Eliminar'),
          },
          // ... Más
          {
            tipo: 'material',
            icon: 'more_vert',
            tooltip: 'Más acciones',
            children: [
              // Exportar eventos
              {
                tipo: 'material',
                color: 'primary',
                icon: 'file_download',
                tooltip: 'Exportar eventos',
                click: (dato) => this.exportarEventos(dato),
                disabled: () =>
                  !this.helper.tienePermiso('Alarmas - Exportar eventos'),
              },
              // Dar de alta
              {
                tipo: 'material',
                color: 'primary',
                icon: 'event_available',
                tooltip: 'Dar de alta',
                click: (dato) => this.darAlta(dato),
                oculta: (dato) => !!dato.fechaAlta,
                disabled: () =>
                  !this.helper.tienePermiso('Alarmas - Dar de alta'),
              },
              // Actualizar imágenes
              {
                tipo: 'material',
                color: 'primary',
                icon: 'add_photo_alternate',
                tooltip: 'Actualizar imágenes',
                click: (dato) => this.actualizarImagenes(dato),
                oculta: (dato) => !dato.fechaAlta,
                disabled: () =>
                  !this.helper.tienePermiso('Alarmas - Actualizar imágenes'),
              },
              // Cambiar de cliente
              {
                tipo: 'material',
                color: 'primary',
                icon: 'drive_file_move',
                tooltip: 'Cambiar de cliente',
                click: (dato) => this.cambiarCliente(dato),
                disabled: () =>
                  !this.helper.tienePermiso('Alarmas - Cambiar de cliente'),
              },
              // Configurar comunicador
              {
                tipo: 'material',
                color: 'primary',
                icon: 'tune',
                tooltip: 'Configurar comunicador',
                click: (dato) => this.configurarComunicador(dato),
                disabled: () =>
                  !this.helper.tienePermiso('Alarmas - Configurar comunicador'),
              },
              // Evento técnico (servicio técnico o verificación)
              {
                tipo: 'material',
                color: 'primary',
                icon: 'build',
                tooltip: 'Servicio técnico',
                click: (dato) => this.eventoTecnico(dato),
                disabled: () =>
                  !this.helper.tienePermiso(
                    'Alarmas - Solicitar servicio técnico',
                  ),
              },
              // Cambiar estado de la cuenta
              {
                tipo: 'material',
                color: 'primary',
                icon: 'manage_accounts',
                tooltip: 'Cambiar estado de la cuenta',
                click: (dato) => this.crearEstadoEntidad(dato),
                oculta() {
                  return HelperService.getTipoCliente() === 'Final';
                },
                disabled: () =>
                  !this.helper.tienePermiso(
                    'Alarmas - Cambiar estado de cuenta',
                  ),
              },
              // Modo desactivado
              {
                tipo: 'material',
                color: 'primary',
                icon: 'do_not_disturb_on',
                tooltip: 'Modo desactivado',
                click: (dato) => this.modoDesactivado(dato),
                disabled: () =>
                  !this.helper.tienePermiso(
                    'Alarmas - Cambiar modo desactivado',
                  ),
              },
              // Ver stream
              {
                tipo: 'material',
                color: 'primary',
                icon: 'videocam',
                tooltip: 'Ver cámaras en vivo',
                click: (dato) => this.verStream(dato),
                disabled: (dato) =>
                  !this.permisosEntidades.verModuloCamaras() ||
                  !this.helper.tienePermiso('Cámaras - Ver streaming') ||
                  !dato.camaras ||
                  dato.camaras.length === 0,
              },
              // Re-chequear estado (local + vendor)
              {
                tipo: 'material',
                color: 'primary',
                icon: 'refresh',
                tooltip: 'Volver a chequear el estado',
                click: (dato) => this.rechequearEstado(dato),
              },
              // Ver detalle de estado (cached, sin re-pegar)
              {
                tipo: 'material',
                color: 'primary',
                icon: 'info',
                tooltip: 'Ver detalle del estado',
                click: (dato) => this.verDetalleEstado(dato),
                oculta: (dato) => {
                  const r = this.isAliveMap[dato._id || ''];
                  return !r || r.estado === 'online';
                },
              },
            ],
          },
        ],
      },
    });

    this.columnas = columnas;
  }
  // Hooks

  async ngOnInit() {
    this.loading = true;
    if (HelperService.getTipoCliente() !== 'Final') {
      this.filtros.push(this.cliente);
      this.filtros.push(this.ancestro);
    }
    this.setColumnas();
    await this.listar();
    this.loading = false;
  }

  async ngOnDestroy() {
    this.alarmasDomiciliarias$?.unsubscribe();
  }
}
